<template>
  <div id="app">   
    <router-view/>
  </div>
</template>
<script>


export default {
  components:{
    
  },
  mounted() {
    
  },
  methods: { 
   
  },
}
</script>
<style>
html,body{ font-size: 13.33vw;}
#app {}
html {
  -webkit-text-size-adjust: none; /* 针对iOS 5.0+ */
  -moz-text-size-adjust: none; /* 针对Firefox */
  -ms-text-size-adjust: none; /* 针对IE和Edge */
  text-size-adjust: none; /* 标准语法 */
}
</style>
